module.exports = __webpack_public_path__ + "static/media/hea_bio_age.df70acef.png";